/**
 * 全局声音控制器。组件本身不渲染 DOM，只负责 Howler 实例和事件订阅。
 * 背景音乐直接响应 enabled；点击音效通过 document 事件委托覆盖所有 data-sound 按钮。
 */
import { Howl } from 'howler';
import { useEffect, useState } from 'react';
// @ts-ignore
import delegate from 'delegate';
import { useSoundConfigState } from '../../../atoms/sound-config';

const Sounds = () => {
    const [soundConfig] = useSoundConfigState();
    // 使用 useState 的惰性初始化，确保每次组件生命周期只创建一个 Howl 实例。
    const [ambientSound] = useState<Howl>(
        () =>
            new Howl({
                src: ['/sounds/ambience.mp3'],
                loop: true,
            }),
    );
    const [clickSound] = useState<Howl>(
        () =>
            new Howl({
                src: ['/sounds/click-new.wav'],
                volume: 0.75,
            }),
    );

    /** 根据全局开关播放、淡入或暂停循环背景音乐。 */
    useEffect(() => {
        if (soundConfig.enabled) {
            ambientSound.play();
            ambientSound.fade(0, 1, 500);
        } else {
            ambientSound.pause();
        }

        return () => {
            ambientSound.pause();
        };
    }, [ambientSound, soundConfig.enabled]);

    /**
     * 监听整个 document 上带 data-sound="click" 的元素。
     * 新增按钮时只需添加该属性，无需再接入一份音频逻辑。
     */
    useEffect(() => {
        const delegation = delegate(
            document,
            '[data-sound="click"]',
            'click',
            () => {
                if (soundConfig.enabled) {
                    clickSound.play();
                }
            },
        );

        // effect 重跑或组件卸载时销毁委托，避免重复绑定。
        return () => delegation.destroy();
    }, [clickSound, soundConfig.enabled]);

    return null;
};

export default Sounds;
